import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Notice, Pager } from "../../lib/ui";

/* All purchase orders – port of fetch_po_list.php (API: GET /api/purchase-orders). Open a PO to edit, approve or reject it while Pending. */

const tone = (s) => ({ pending: "warn", approved: "ok", rejected: "err" }[String(s).toLowerCase()] || "");

export default function PoList() {
  const api = useApi();
  const [q, setQ] = useState({ query: "", status: "", page: 1 });
  const [term, setTerm] = useState("");
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async (p) => { try { setD(await api.get("/api/purchase-orders", p)); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(q); }, [load, q]);
  useEffect(() => { const t = setTimeout(() => setQ((s) => (s.query === term ? s : { ...s, query: term, page: 1 })), 300); return () => clearTimeout(t); }, [term]);
  return (
    <main className="pg">
      <PageHeader slug="po_list" actions={<Link to="/purchase_order" className="btn primary"><i className="fas fa-plus" /> Create PO</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        <div className="toolbar">
          <div className="seg-filter" role="group" aria-label="Status">{["", "Pending", "Approved"].map((s) => (
            <button key={s || "all"} type="button" aria-pressed={q.status === s} onClick={() => setQ({ ...q, status: s, page: 1 })}>{s || "All"} <span>{s ? (d?.counts?.[s] ?? "") : ""}</span></button>))}</div>
          <div className="field grow"><div className="search"><i className="fas fa-magnifying-glass" /><input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search supplier or status" aria-label="Search purchase orders" /></div></div>
        </div>
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr><th>PO #</th><th>Date</th><th>Supplier</th><th className="num">Amount (TZS)</th><th>Status</th><th /></tr></thead>
          <tbody>{d?.rows.map((r) => <tr key={r.po_id}><td className="mono">#{r.po_id}</td><td>{String(r.po_date).slice(0, 10)}</td><td style={{ fontWeight: 600, color: "var(--ink)" }}>{r.client_name}</td>
            <td className="num mono">{n2(r.amount)}</td><td><span className={`pill-tag ${tone(r.status)}`}>{r.status}</span></td>
            <td><Link className="btn sm" to={`/po/${r.po_id}`}>{r.status === "Pending" ? "Review" : "View"}</Link></td></tr>)}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-file-contract" />No purchase orders found.</div>}</div>
        {d && <Pager page={d.page} totalPages={d.pages} onPage={(p) => setQ({ ...q, page: p })} />}
      </section>
    </main>
  );
}
